import { clsx } from "clsx";

import type { HTMLAttributes } from "react";

export default function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        "animate-pulse shrink-0 bg-black-300",
        (className.includes(":rounded-") || !className.includes("rounded-")) &&
          "rounded-md",
        className,
      )}
      {...props}
    />
  );
}
